var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.classBase + 'app', _vm.grayBody ? 'gary-body' : ''],attrs:{"id":"app"}},[_c('router-view'),_c('Login'),_c('AuthRealName'),_c('CheckUnderage'),_c('LoginVerifyTips')],1)}
var staticRenderFns = []

export { render, staticRenderFns }